Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getBackgroundColorOfQualifier = getBackgroundColorOfQualifier;
exports.hasBackgroundColor = hasBackgroundColor;
exports.getTextColorOfQualifier = getTextColorOfQualifier;

function getBackgroundColorOfQualifier(teamQualification) {
  if (!teamQualification) {
    return 'background.main';
  }

  switch (teamQualification.qualify) {
    case 'Champions_League':
      return 'standings_qualify.champions_league';

    case 'Champions_League_Qualifying':
      return 'standings_qualify.champions_league_quali';

    case 'Europa_Cup':
      return teamQualification.qualifyType === 'Group' ? 'standings_qualify.europa_league' : 'standings_qualify.europa_league_quali';

    case 'Relegation':
      return teamQualification.method === 'Playoff_Relegation' || teamQualification.method === 'Play_Off' ? 'standings_qualify.way_down_relegation' : 'standings_qualify.way_down';

    case 'Promotion':
      return teamQualification.method === 'Playoff_Promotion' || teamQualification.method === 'Play_Off' ? 'standings_qualify.europa_league' : 'standings_qualify.champions_league';

    default:
      return 'background.main';
  }
}

function hasBackgroundColor(teamQualification) {
  if (!teamQualification) {
    return false;
  }

  switch (teamQualification.qualify) {
    case 'Champions_League':
    case 'Champions_League_Qualifying':
    case 'Europa_Cup':
    case 'Promotion':
      return true;

    case 'Relegation':
      return teamQualification.method === 'League_Position';

    default:
      return false;
  }
}

function getTextColorOfQualifier(teamQualification) {
  if (hasBackgroundColor(teamQualification)) {
    return 'font.enclosed';
  }

  return 'font.main';
}